import React, { useCallback, useEffect, useState } from "react";
import { PreviewProudctModalBaseData } from "./PreviewProudctModalBaseData";
import { ProductsService } from "../service";
import { ErrorToast } from "../../../shared/toasters/toasters";
import { PreviewProudctModalAttributes } from "./PreviewProudctModalAttributes";
import { PreviewProudctModalVariations } from "./PreviewProudctModalVariations";
interface Props {
  productBaseData: any;
  setProductBaseData: any;
  isWorkflow?: boolean;
  usedLanguagesArray?: any;
}
export const PreviewProductModal = ({
  productBaseData,
  setProductBaseData,
  usedLanguagesArray,
  isWorkflow = false,
}: Props) => {
  return (
    <div className="row">
      <div className="col-md-8">
        <PreviewProudctModalBaseData
          currentProduct={productBaseData}
          setCurrentProduct={setProductBaseData}
          usedLanguagesArray={usedLanguagesArray}
        />
      </div>
      <div className="col-md-4">
        {" "}
        <PreviewProudctModalAttributes
          currentProduct={productBaseData}
          setCurrentProduct={setProductBaseData}
        />
        <PreviewProudctModalVariations
          currentProduct={productBaseData}
          setCurrentProduct={setProductBaseData}
          isWorkflow={isWorkflow}
        />
      </div>
    </div>
  );
};
